const Footer = () => {
    return (
        <footer>
            <div className="container">
                <p>Made by Rohit Kanojiya</p>
            </div>
        </footer>
    )
}
export default Footer
